import { jsx as L } from "react/jsx-runtime";
const e = ({ size: r }) => {
  switch (r) {
    case "sm":
      return /* @__PURE__ */ L(
        "path",
        {
          d: "M5.89749 11.5019L7.99749 10.2352L10.0975 11.5185L9.54749 9.11853L11.3975 7.51853L8.96416 7.30186L7.99749 5.03519L7.03082 7.28519L4.59749 7.50186L6.44749 9.11853L5.89749 11.5019ZM4.38082 13.5929L5.33599 9.48002L2.14499 6.71469L6.35516 6.34936L7.99749 2.47119L9.63982 6.34936L13.85 6.71469L10.659 9.48002L11.6142 13.5929L7.99749 11.4109L4.38082 13.5929Z",
          fill: "currentColor"
        }
      );
    case "lg":
      return /* @__PURE__ */ L(
        "path",
        {
          d: "M8.845 17.2367L11.995 15.3367L15.145 17.2617L14.32 13.6617L17.095 11.2617L13.445 10.9367L11.995 7.53667L10.545 10.9117L6.895 11.2367L9.67 13.6617L8.845 17.2367ZM6.57 20.3732L8.00275 14.2039L3.21625 10.0559L9.5315 9.50792L11.995 3.69067L14.4585 9.50792L20.7737 10.0559L15.9872 14.2039L17.42 20.3732L11.995 17.1002L6.57 20.3732Z",
          fill: "currentColor"
        }
      );
    case "md":
    default:
      return /* @__PURE__ */ L(
        "path",
        {
          d: "M7.37062 14.3694L9.99562 12.7861L12.6206 14.3902L11.9331 11.3902L14.2456 9.39022L11.2039 9.11939L9.99562 6.28606L8.78728 9.09856L5.74562 9.36939L8.05812 11.3902L7.37062 14.3694ZM5.47478 16.9831L6.66874 11.8421L2.67999 8.38543L7.9427 7.92876L9.99562 3.08105L12.0485 7.92876L17.3112 8.38543L13.3225 11.8421L14.5165 16.9831L9.99562 14.2556L5.47478 16.9831Z",
          fill: "currentColor"
        }
      );
  }
}, l = ({ size: r }) => {
  switch (r) {
    case "sm":
      return /* @__PURE__ */ L(
        "path",
        {
          d: "M5.96892 11.5063L7.99325 10.2875L10.0176 11.523L9.48342 9.21468L11.2698 7.67051L8.92409 7.46185L7.99325 5.27885L7.06242 7.44918L4.71675 7.65385L6.50309 9.21068L5.96892 11.5063ZM3.67725 14.6723L4.81642 9.76185L1.00375 6.45635L6.03492 6.02385L7.99325 1.39185L9.95159 6.02385L14.9828 6.45635L11.1701 9.76185L12.3093 14.6723L7.99325 12.0655L3.67725 14.6723Z",
          fill: "currentColor"
        }
      );
    case "lg":
      return /* @__PURE__ */ L(
        "path",
        {
          d: "M8.95927 17.2435L11.9958 15.4153L15.0323 17.2685L14.231 13.806L16.9105 11.4898L13.392 11.1768L11.9958 7.90228L10.5995 11.1578L7.08102 11.4648L9.76052 13.8L8.95927 17.2435ZM5.52177 21.9925L7.23052 14.6268L1.51152 9.66853L9.05827 9.01978L11.9958 2.07178L14.9333 9.01978L22.48 9.66853L16.761 14.6268L18.4698 21.9925L11.9958 18.0823L5.52177 21.9925Z",
          fill: "currentColor"
        }
      );
    case "md":
    default:
      return /* @__PURE__ */ L(
        "path",
        {
          d: "M7.46423 14.3748L9.99464 12.8513L12.5251 14.3956L11.8573 11.5102L14.0903 9.58002L11.1582 9.31919L9.99464 6.59044L8.8311 9.30336L5.89902 9.55919L8.13193 11.5052L7.46423 14.3748ZM4.59964 18.3323L6.0236 12.1942L1.25777 8.06231L7.54673 7.52169L9.99464 1.73169L12.4426 7.52169L18.7315 8.06231L13.9657 12.1942L15.3896 18.3323L9.99464 15.0738L4.59964 18.3323Z",
          fill: "currentColor"
        }
      );
  }
}, a = ({
  size: r = "md",
  weight: t = "default"
}) => {
  switch (t) {
    case "bold":
      return /* @__PURE__ */ L(l, { size: r });
    case "book":
    case "default":
      return /* @__PURE__ */ L(e, { size: r });
  }
};
export {
  a as default
};
//# sourceMappingURL=DIconStar.js.map
